// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall } from "../utils/apiHelper";

const useCaseService = {
  listUseCases: async () =>
    handleApiCall(
      () => apiClient.get("/admin/use-cases/"),
      "Error fetching use cases",
    ),

  getScenarioUseCases: async (scenarioId) =>
    handleApiCall(
      () => apiClient.get(`/admin/use-cases/scenarios/${scenarioId}/use-cases`),
      `Error fetching scenario use cases ${scenarioId}`,
    ),

  assignScenarioUseCase: async (scenarioId, payload) =>
    handleApiCall(
      () =>
        apiClient.post(
          `/admin/use-cases/scenarios/${scenarioId}/use-cases`,
          payload,
        ),
      `Error assigning use case to scenario ${scenarioId}`,
    ),

  removeScenarioUseCase: async (scenarioId, useCaseId) =>
    handleApiCall(
      () =>
        apiClient.delete(
          `/admin/use-cases/scenarios/${scenarioId}/use-cases/${useCaseId}`,
        ),
      `Error removing use case ${useCaseId} from scenario ${scenarioId}`,
    ),

  getSpaceUseCases: async (spaceId) =>
    handleApiCall(
      () => apiClient.get(`/admin/use-cases/spaces/${spaceId}/use-cases`),
      `Error fetching space use cases ${spaceId}`,
    ),

  assignSpaceUseCase: async (spaceId, payload) =>
    handleApiCall(
      () =>
        apiClient.post(`/admin/use-cases/spaces/${spaceId}/use-cases`, payload),
      `Error assigning use case to space ${spaceId}`,
    ),

  updateSpaceUseCase: async (spaceId, useCaseId, payload) =>
    handleApiCall(
      () =>
        apiClient.put(
          `/admin/use-cases/spaces/${spaceId}/use-cases/${useCaseId}`,
          payload,
        ),
      `Error updating space ${spaceId} use case ${useCaseId}`,
    ),

  removeSpaceUseCase: async (spaceId, useCaseId) =>
    handleApiCall(
      () =>
        apiClient.delete(
          `/admin/use-cases/spaces/${spaceId}/use-cases/${useCaseId}`,
        ),
      `Error removing use case ${useCaseId} from space ${spaceId}`,
    ),
};

export default useCaseService;
